export default __webpack_public_path__ + "static/media/T_59_desktop.a524d835.jpg";